let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("kFOec"), load("9VvWo"), load("3qsjq"), load("lUlCu"), load("cS7dz")]).then(() => parcelRequire('ec8HN'));